/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

import React, {useState, useEffect} from 'react';
import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
import HistoryOutlinedIcon from '@material-ui/icons/HistoryOutlined';

export default function NavHistory(props)
{
    const [navHistory, setNavHistory] = useState(false);

    /** Set activity panel to value being passed through props */
    useEffect(() => {
        setNavHistory(props.value);
    },[props.value]);
    
    /**Handle changes to activity panel checkbox */
    const handleNavHistory = () => {
        setNavHistory(!navHistory);
        props.onChange(!navHistory)
    }

    return(
        <div>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={navHistory}
                        onChange={handleNavHistory}
                        name="navHistory"
                        color="primary"
                        />
                    }
                    label="Navigation History"
                    />
                </Grid>
                <Grid item>
                    <Tooltip title="Allow navigation history access">
                        <HistoryOutlinedIcon color="primary"/>
                    </Tooltip>
                </Grid>
            </Grid>
        </div>
    );
}

